<template>
    <svg
        width="43"
        height="39"
        viewBox="0 0 43 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_ii_1282_1400)">
            <path
                d="M33.642 23.0901C34.2398 24.5646 33.7273 26.2563 32.4119 27.1513L29.0742 29.4222C24.2969 32.6726 18.0183 32.6725 13.2411 29.422L9.90394 27.1514C8.58852 26.2563 8.07613 24.5646 8.67385 23.0901L12.2962 14.1543C13.3296 11.605 15.8056 9.93697 18.5564 9.93697L23.7595 9.93697C26.5103 9.93697 28.9863 11.605 30.0197 14.1543L33.642 23.0901Z"
                fill="url(#paint0_linear_1282_1400)"
            />
        </g>
        <foreignObject
            x="4.00543e-05"
            y="-0.0007689"
            width="42.3161"
            height="38.6571"
            ><div
                xmlns="http://www.w3.org/1999/xhtml"
                style="
                    backdrop-filter: blur(0.95px);
                    clip-path: url(#bgblur_0_1282_1400_clip_path);
                    height: 100%;
                    width: 100%;
                "
            ></div
        ></foreignObject>
        <g
            filter="url(#filter1_ddii_1282_1400)"
            data-figma-bg-blur-radius="1.89729"
        >
            <path
                d="M8.67389 13.9178C8.07616 12.4432 8.58859 10.7515 9.90405 9.85647L12.925 7.80103C17.8934 4.42063 24.4232 4.42071 29.3915 7.80124L32.412 9.85645C33.7274 10.7515 34.2398 12.4432 33.6421 13.9177L30.0197 22.8535C28.9863 25.4028 26.5103 27.0708 23.7595 27.0708H18.5564C15.8056 27.0708 13.3296 25.4028 12.2962 22.8535L8.67389 13.9178Z"
                fill="url(#paint1_radial_1282_1400)"
                shape-rendering="crispEdges"
            />
        </g>
        <foreignObject x="16.9668" y="11.1897" width="6.32568" height="13.0425"
            ><div
                xmlns="http://www.w3.org/1999/xhtml"
                style="
                    backdrop-filter: blur(0.31px);
                    clip-path: url(#bgblur_1_1282_1400_clip_path);
                    height: 100%;
                    width: 100%;
                "
            ></div
        ></foreignObject>
        <g
            filter="url(#filter2_ii_1282_1400)"
            data-figma-bg-blur-radius="0.618893"
        >
            <path
                d="M20.1463 23.6133V15.8483H17.5857V14.0027H18.5999C19.3315 14.0027 19.8581 13.8475 20.1795 13.5371C20.501 13.2157 20.6617 12.6393 20.6617 11.8079H22.6736V23.6133H20.1463Z"
                fill="url(#paint2_linear_1282_1400)"
                fill-opacity="0.9"
            />
        </g>
        <defs>
            <filter
                id="filter0_ii_1282_1400"
                x="8.42603"
                y="9.9375"
                width="25.6713"
                height="22.0903"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="0.168411" />
                <feGaussianBlur stdDeviation="0.682746" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1282_1400"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.20769" dy="0.103845" />
                <feGaussianBlur stdDeviation="0.113791" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_innerShadow_1282_1400"
                    result="effect2_innerShadow_1282_1400"
                />
            </filter>
            <filter
                id="filter1_ddii_1282_1400"
                x="4.00543e-05"
                y="-0.0007689"
                width="42.3161"
                height="38.6571"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="3.15984" />
                <feGaussianBlur stdDeviation="4.21311" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0483312 0 0 0 0 0.0581742 0 0 0 0 0.245192 0 0 0 0.33 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1282_1400"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.89729" />
                <feGaussianBlur stdDeviation="0.948644" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0566522 0 0 0 0 0.0916705 0 0 0 0 0.206731 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_1282_1400"
                    result="effect2_dropShadow_1282_1400"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_1282_1400"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.101982" dy="0.101982" />
                <feGaussianBlur stdDeviation="0.0732943" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.62 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect3_innerShadow_1282_1400"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.26188" dy="0.26188" />
                <feGaussianBlur stdDeviation="1.3094" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect3_innerShadow_1282_1400"
                    result="effect4_innerShadow_1282_1400"
                />
            </filter>
            <clipPath
                id="bgblur_0_1282_1400_clip_path"
                transform="translate(-4.00543e-05 0.0007689)"
            >
                <path
                    d="M8.67389 13.9178C8.07616 12.4432 8.58859 10.7515 9.90405 9.85647L12.925 7.80103C17.8934 4.42063 24.4232 4.42071 29.3915 7.80124L32.412 9.85645C33.7274 10.7515 34.2398 12.4432 33.6421 13.9177L30.0197 22.8535C28.9863 25.4028 26.5103 27.0708 23.7595 27.0708H18.5564C15.8056 27.0708 13.3296 25.4028 12.2962 22.8535L8.67389 13.9178Z"
                />
            </clipPath>
            <filter
                id="filter2_ii_1282_1400"
                x="16.9668"
                y="11.1897"
                width="6.32568"
                height="13.0425"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.0076732" dy="0.691235" />
                <feGaussianBlur stdDeviation="0.24687" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.00134747 0 0 0 0 0.00134747 0 0 0 0 0.00134747 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1282_1400"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.0617174" dy="0.0617174" />
                <feGaussianBlur stdDeviation="0.00925761" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.62 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_innerShadow_1282_1400"
                    result="effect2_innerShadow_1282_1400"
                />
            </filter>
            <clipPath
                id="bgblur_1_1282_1400_clip_path"
                transform="translate(-16.9668 -11.1897)"
            >
                <path
                    d="M20.1463 23.6133V15.8483H17.5857V14.0027H18.5999C19.3315 14.0027 19.8581 13.8475 20.1795 13.5371C20.501 13.2157 20.6617 12.6393 20.6617 11.8079H22.6736V23.6133H20.1463Z"
                />
            </clipPath>
            <linearGradient
                id="paint0_linear_1282_1400"
                x1="28.0151"
                y1="4.50928"
                x2="3.95493"
                y2="20.5742"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#359DFF" />
                <stop offset="0.619007" stop-color="#2665DA" />
                <stop offset="1" stop-color="#002682" />
            </linearGradient>
            <radialGradient
                id="paint1_radial_1282_1400"
                cx="0"
                cy="0"
                r="1"
                gradientTransform="matrix(-23.9509 32.8569 -31.1249 -25.1589 38.4015 14.635)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#006EFF" stop-opacity="0" />
                <stop offset="1" stop-color="#006EFF" />
            </radialGradient>
            <linearGradient
                id="paint2_linear_1282_1400"
                x1="16.6885"
                y1="13.9569"
                x2="6.29466"
                y2="25.8459"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="white" />
                <stop offset="0.487861" stop-color="#B7B7B7" />
                <stop offset="1" stop-color="#707070" />
            </linearGradient>
        </defs>
    </svg>
</template>
